<div class="header-and-search">
  <h4>{{'event_steps.step_location.location_placeholder' | translate}}</h4>
  <div class="location-selector">
    <location-search-field [data]="selectedLocationNameWritable()" [includePOI]="true"
      (locationChanged)="onCustomLocationChanged($event)"></location-search-field>
  </div>
</div>
<div class="map-container">
  <azure-map #mapelement></azure-map>
</div>